<template>
  <div>
    <textarea :id="id" />
  </div>
</template>

<script>
import tinymce from "tinymce/tinymce";
// Базовые модули, обязательные для TinyMCE 6/7 (в 4.x их не было)
import "tinymce/icons/default";
import "tinymce/themes/silver";
import "tinymce/models/dom";
import "tinymce/skins/ui/oxide/skin.min.css";

import "@/plugins/wysiwyg/ru.js";
import "@/plugins/wysiwyg/maxchars.js";

import "tinymce/plugins/advlist";
import "tinymce/plugins/autolink";
import "tinymce/plugins/link";
import "tinymce/plugins/media";
import "tinymce/plugins/code";
import "tinymce/plugins/image";
import "tinymce/plugins/lists";
import "tinymce/plugins/preview";
import "tinymce/plugins/table";
// Плагины colorpicker / textcolor / paste встроены в ядро TinyMCE 6/7.
// Плагин imagetools удалён в 6+ (его функционал стал premium-плагином editimage).

export default {
  name: "Wysiwyg",
  props: {
    id: {
      type: String,
      default: () => {
        return `tinymce_${Math.random().toString(16).slice(2)}`;
      },
    },
    maxLength: {
      type: Number,
      default: 0,
    },
    value: {
      type: String,
      default: "",
    },
    height: {
      type: [Number, String],
      required: false,
      default: 250,
    },
    plugins: {
      type: Array,
      default: () => {
        return [
          "advlist autolink lists link image preview",
          "code",
          "media table",
          "maxchars",
        ];
      },
    },
    menubar: {
      type: String,
      default: "",
      // default: 'file edit insert view format table'
    },
    toolbar: {
      type: Array,
      default: () => [
        "blocks bold italic underline strikethrough alignleft aligncenter alignright outdent indent blockquote undo redo removeformat subscript superscript code",
        "bullist numlist link image preview media table forecolor backcolor",
      ],
    },
  },
  data() {
    return {
      content: "",
      checkerTimeout: null,
      isTyping: false,
      editor: null,
    };
  },
  watch: {
    value: function (newValue) {
      newValue = newValue || "";
      if (!this.isTyping) {
        if (this.editor !== null) {
          this.editor.setContent(newValue);
        } else {
          this.content = newValue;
        }
      }
    },
  },
  mounted() {
    this.content = this.value;
    this.init();
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.remove();
    }
  },
  methods: {
    init() {
      const options = {
        selector: `#${this.id}`,
        // GPL-лицензия: внутренняя self-hosted админка, premium-функции не используются
        license_key: "gpl",
        language: "ru",
        // Скин UI подключён через import выше, content-стили задаём вручную
        skin: false,
        content_css: false,
        menubar: this.menubar,
        toolbar: this.toolbar,
        // В TinyMCE 6/7 каждый элемент массива plugins — отдельное имя плагина.
        // Нормализуем многословные строки (формат 4.x) в плоский список имён.
        plugins: this.plugins.join(" ").split(/\s+/).filter(Boolean),
        height: this.height,
        // оставляем стили доступные из редактора
        // стили font-family и т.п. отключаем
        valid_styles: {
          "*": "text-decoration text-align color background-color",
        },
        content_style:
          "body{font-family:Helvetica,Arial,sans-serif;font-size:14px}",
        setup: (editor) => {
          editor.maxChars = this.maxLength;
        },
        init_instance_callback: this.initEditor,
      };
      tinymce.init(options);
    },
    initEditor(editor) {
      this.editor = editor;
      editor.on("KeyUp", () => {
        this.getContent();
      });
      editor.on("Change", () => {
        if (this.editor.getContent() !== this.value) {
          this.getContent();
        }
      });

      editor.setContent(this.content);
      // this.$emit('input', this.content)
    },
    getContent() {
      this.isTyping = true;
      if (this.checkerTimeout !== null) clearTimeout(this.checkerTimeout);
      this.checkerTimeout = setTimeout(() => {
        this.isTyping = false;
      }, 300);
      this.$emit("input", this.editor.getContent());
    },
  },
};
</script>
